import { jsx } from 'react/jsx-runtime';
var StripePaymentButton = function StripePaymentButton(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    renderPaymentButton = _ref.renderPaymentButton;
  var defaultRenderButton = function defaultRenderButton(_ref2) {
    var disabled = _ref2.disabled,
      type = _ref2.type;
    return jsx("button", {
      disabled: disabled,
      type: type,
      children: "Place order and pay"
    });
  };
  var renderButton = renderPaymentButton !== null && renderPaymentButton !== void 0 ? renderPaymentButton : defaultRenderButton;
  return renderButton({
    disabled: isDisabled,
    type: 'submit'
  });
};
export { StripePaymentButton as default };